import { render, staticRenderFns } from "./SubscriptionOverview.vue?vue&type=template&id=84c86f66&"
import script from "./SubscriptionOverview.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports